import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { ItemFormGroupComponent } from "./components/item-form-group/item-form-group.component";
import { ButtonModule } from "../../button/button.module";
import { LoadingIndicatorModule } from "../../loading-indicator/loading-indicator.module";

@NgModule({
	declarations: [ItemFormGroupComponent],
	imports: [CommonModule, TranslateModule, ButtonModule, LoadingIndicatorModule],
	exports: [ItemFormGroupComponent],
})
export class ItemFormGroupModule {}
